// extracted by mini-css-extract-plugin
export default {"overlay":"KB-z","bodyOpen":"LB-z","content":"MB-z","header":"NB-z","close":"OB-z","closeNoHeading":"PB-z"};